import * as actionType from 'ActionTypes';

export const setFilterMarkers = (markers) => {
	return {
		type: actionType.SET_MARKERS,
		list: markers
	};
};

// export const setSelectedMarkers = (markers) => {
// 	return {
// 		type: actionType.SET_SELECTED_MARKERS,
// 		list: markers
// 	};
// };

export const setOriginMarkers = (markers) => {
	return {
		type: actionType.SET_ORIGIN_MARKER,
		list: markers
	};
};

export const getMarkersRequest = () => {
	return {
		type: actionType.GET_MARKERS_REQUEST
	};
};

export const getMarkersFail = () => {
	return {
		type: actionType.GET_MARKERS_FAIL
	};
};

export const setSelectedMarker = (marker) => {
	return {
		type: actionType.SET_SELECTED_MARKER,
		selectedMarker: marker
	};
};